import React, { useState, useEffect } from 'react'
import Modal from 'react-modal'
import { graphql, useStaticQuery } from 'gatsby'
import classNames from 'classnames'
import { Link, NavBarItems } from 'newComponents'
import { track } from '../../../utils/thirdPartyUtils'

import horizontalLogo from '../../../images/logos/LaunchDarkly_Horizontal_Primary_Logo_on_Light_RGB.svg'

const handleDemoLinkClick = () => {
  track('Request Demo Button Clicked')
}

const NavbarComponent = (props) => {
  // props data
  const { navbar, appUrl, imageHeader, toggleBanner, staticNavbar } = props

  // state
  const [isScrolled, setIsScrolled] = useState(false)
  const [isActive, setIsActive] = useState(false)
  const [fixedTop, setFixedTop] = useState(false)

  // functions
  const handleNavDropdown = () => {
    setIsActive(!isActive)
  }

  const handleBurgerClick = () => {
    setIsActive(!isActive)
  }

  const updateFixedtop = () => {
    setFixedTop(window.matchMedia('(max-width: 1086px)').matches)
  }

  const updateScrollClass = () => {
    if (typeof window !== `undefined`) {
      if (window.pageYOffset > 50) {
        setIsScrolled(true)
      } else {
        setIsScrolled(false)
      }
    }
  }

  // component did mount
  useEffect(() => {
    updateFixedtop()
    window.addEventListener('resize', updateFixedtop)
    window.addEventListener('scroll', updateScrollClass)
    Modal.setAppElement('#main')
    return () => {
      window.removeEventListener('resize', updateFixedtop)
      window.removeEventListener('scroll', updateScrollClass)
    }
  })

  // classnames library takes a string (constant class) and object with variable classname if boolean
  const classes = classNames('navbar new-container nav-fixed', {
    'image-background': imageHeader,
    'is-scrolled': isScrolled,
    'has-modal': isActive,
    'is-fixed-top': fixedTop
  })

  const navbarPosition = staticNavbar ? 'static' : ''

  return (
    <header className={`header-style ${navbarPosition}`}>
      <nav role="navigation" className={classes}>
        <div className="navbar-brand" id="main">
          {/* L O G O */}
          <Link className="navbar-logo" to="/" aria-label="Homepage">
            <img className="navbar-icon" src={horizontalLogo} alt="launchdarkly logo of rocketship and text" />
          </Link>
          {/* N A V   B U R G E R */}
          <div
            className={classNames('navbar-burger', { 'is-active': isActive })}
            data-target="headerNav"
            onClick={handleBurgerClick}
          >
            <span />
            <span />
            <span />
          </div>
        </div>

        <div
          className={classNames('navbar-menu', {
            'is-active': isActive
          })}
          id="headerNav"
        >
          <div className="dropdown-background" />
          <div className="navbar-start" id="navbar" role="menubar">
            {navbar.map((item, i) => (
              <NavBarItems item={item} key={i} onHandleDropDown={handleNavDropdown} />
            ))}
          </div>
          <div className="navbar-end" onClick={toggleBanner}>
            <a className="navbar-item navbar-signin-cta" href={appUrl}>
              <span className="navbar-item-name">Sign In</span>
            </a>

            <Link
              to="/request-a-demo/"
              className="navbar-item modal-trigger free-trial-label"
              onClick={handleDemoLinkClick}
            >
              Get a Demo
            </Link>
            {/* Mobile nav CTAs */}
            <a className="navbar-item navbar-mobile-signin-cta" href={appUrl}>
              <span className="navbar-item-name">Sign In</span>
            </a>
            <Link
              to="/request-a-demo/"
              className="button is-large is-primary navbar-mobile-demo-cta"
              onClick={handleDemoLinkClick}
            >
              Get a Demo
            </Link>
          </div>
        </div>
      </nav>
    </header>
  )
}

const Navbar = (props) => {
  const query = graphql`
    query NavBarHomepageQuery {
      site {
        siteMetadata {
          params {
            appUrl
          }
        }
      }
      prismicSettings {
        data {
          sub_links {
            parent_nav_item
            parent_category
            icon {
              url
              localFile {
                childImageSharp {
                  fluid(maxWidth: 2000, quality: 90) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
            link_text {
              text
            }
            link_url {
              url
            }
          }
        }
      }
    }
  `

  const data = useStaticQuery(query)
  const { prismicSettings } = data
  const { data: navData } = prismicSettings
  const { sub_links: sublinks } = navData

  const navBarData = [
    {
      name: 'Product',
      url: null,
      dropdown: [
        { name: 'CORE FEATURES', children: [] },
        { name: 'CONNECTIVITY', children: [] },
        { name: 'DATA', children: [] }
      ]
    },
    {
      name: 'Solutions',
      url: null,
      dropdown: [
        { name: 'TEAM', children: [] },
        { name: 'USE CASES', children: [] }
      ]
    },
    { name: 'Pricing', url: '/pricing' },
    {
      name: 'Customers',
      url: null,
      dropdown: [
        { name: 'SUCCESS STORIES', children: [] },
        { name: 'CASE STUDIES', children: [] }
      ]
    },
    {
      name: 'Resources',
      url: null,
      dropdown: [
        { name: 'EXPLORE', children: [] },
        { name: 'CONTACT', children: [] }
      ]
    }
  ]

  sublinks.forEach((sublink) => {
    const { parent_nav_item: parent, parent_category: category, icon, link_text: text, link_url: url } = sublink
    navBarData.forEach((navItem) => {
      const { name, dropdown } = navItem
      if (name === parent) {
        dropdown.forEach((linksCategory) => {
          const { name: dropdownName, children} = linksCategory
          if (dropdownName === category) {
            children.push({ icon, name: text.text, url: url.url })
          }
        })
      }
    })
  })

  const { toggleBanner, staticNavbar } = props
  return (
    <NavbarComponent
      navbar={navBarData}
      appUrl={data.site.siteMetadata.params.appUrl}
      images={data.prismicSettings.data.sub_links.icon}
      toggleBanner={toggleBanner}
      staticNavbar={staticNavbar}
    />
  )
}

export default Navbar
